(function () {
  function initialise(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-grid]'), status = root.querySelector('[data-status]');
    const tools = root.querySelector('[data-tools]'), az = root.querySelector('[data-az]');
    const search = root.querySelector('[data-search]'), category = root.querySelector('[data-category]');
    const brand = root.querySelector('[data-brand]'), sort = root.querySelector('[data-sort]');
    const allCategoryLabel = category.options[0].text, allBrandLabel = brand.options[0].text;
    let letter = '', complete = false, failed = false, busy = false;
    const more = root.querySelector('[data-load-more]');
    const moreLabel = more.textContent;
    let next = root.querySelector('[data-next]')?.getAttribute('href');
    const seen = new Set();
    const normalise = s => s.toLocaleLowerCase('en-GB').replace(/[^a-z0-9]/g,'');
    let vendors = [];
    try { vendors = JSON.parse(root.querySelector('[data-vendors]').textContent || '[]'); } catch (_) {}
    function remainingVendors() {
      const names = new Set([...grid.children].map(x => normalise(x.dataset.name)));
      return vendors.filter(name => { const key = normalise(name); if(names.has(key)) return false; names.add(key); return true; });
    }
    function appendVendor(name) {
      const item = document.createElement('a'); item.className = 'ufi-brand-item';
      item.dataset.name = name; item.dataset.categories = '[]'; item.dataset.handle = 'vendor:' + name;
      item.href = (window.Shopify?.routes?.root || '/') + 'collections/vendors?q=' + encodeURIComponent(name);
      const fallback = document.createElement('span'); fallback.className = 'ufi-brand-fallback'; fallback.setAttribute('aria-hidden','true'); fallback.textContent = name.slice(0,2).toLocaleUpperCase('en-GB'); item.append(fallback);
      const strong = document.createElement('strong'); strong.textContent = name; item.append(strong);
      const small = document.createElement('small'); small.textContent = root.dataset.rangeLabel; item.append(small); grid.append(item);
    }
    remainingVendors().slice(0, Math.max(0, 50 - grid.children.length)).forEach(appendVendor);
    function availability() {
      complete = !next && !remainingVendors().length;
      more.hidden = complete;
      more.disabled = busy;
      more.textContent = busy ? (root.dataset.loadingLabel || 'Loading brands…') : moreLabel;
      root.setAttribute('aria-busy', String(busy));
    }
    root.querySelector('[data-pagination]').hidden = true;
    // Display shopper-facing groups without modifying collection or product data.
    const categoryLabel = value => {
      const parts = String(value).split('>').map(x => x.trim());
      const text = parts.join(' ').toLowerCase();
      if (/fsdu/.test(text)) return 'Retail Displays';
      if (/baby/.test(text)) return 'Baby';
      if (/pet/.test(text)) return 'Pets';
      if (/toiletries|personal care/.test(text)) return 'Personal Care';
      if (/medicine|health/.test(text)) return 'Health & Wellbeing';
      if (/household/.test(text)) return 'Household';
      if (/frozen/.test(text)) return 'Frozen';
      if (/chilled/.test(text)) return 'Chilled';
      if (/confectionery/.test(text)) return 'Confectionery';
      if (/crisps|snacks/.test(text)) return 'Crisps & Snacks';
      if (/sports|protein/.test(text)) return 'Protein & Sports Nutrition';
      if (/seasonal/.test(text)) return 'Seasonal';
      if (/drinks|beverages/.test(text)) return 'Drinks';
      if (/grocery|groceries/.test(text)) return 'Grocery';
      return parts.at(-1) || '';
    };
    const categories = item => { try { return [...new Set(JSON.parse(item.dataset.categories || '[]').map(categoryLabel))]; } catch (_) { return []; } };
    function options() {
      const items = [...grid.children];
      const currentCategory = category.value, currentBrand = brand.value;
      category.replaceChildren(new Option(allCategoryLabel, ''));
      brand.replaceChildren(new Option(allBrandLabel, ''));
      [...new Set(items.flatMap(categories).filter(Boolean))].sort((a,b) => a.localeCompare(b)).forEach(x => category.add(new Option(x,x)));
      items.map(x => x.dataset.name).sort((a,b) => a.localeCompare(b)).forEach(x => brand.add(new Option(x,x)));
      category.value = currentCategory; brand.value = currentBrand;
    }
    function filter() {
      let count = 0;
      const q = search.value.trim().toLocaleLowerCase('en-GB');
      [...grid.children].sort((a,b) => a.dataset.name.localeCompare(b.dataset.name,'en-GB') * (sort.value === 'desc' ? -1 : 1)).forEach(item => {
        const name = item.dataset.name;
        const initial = name.charAt(0).toUpperCase();
        const match = name.toLocaleLowerCase('en-GB').includes(q) && (!brand.value || brand.value === name) && (!category.value || categories(item).includes(category.value)) && (!letter || (letter === '#' ? !/[A-Z]/.test(initial) : initial === letter));
        item.hidden = !match;
        if(match) count++;
        grid.append(item);
      });
      status.textContent = count + ' ' + (count === 1 ? (root.dataset.singularLabel || 'brand') : (root.dataset.pluralLabel || 'brands')) + (failed ? ' — ' + (root.dataset.loadError || 'Could not load more brands. Please try again.') : busy ? ' — ' + (root.dataset.loadingLabel || 'Loading brands…') : '') + (complete ? '' : ' — ' + (root.dataset.loadedHelp || 'Search and filters apply to loaded brands. Load more to explore the rest of the range.'));
      root.querySelector('[data-empty]').hidden = count !== 0;
    }
    tools.hidden = false; az.hidden = false;
    search.addEventListener('input',filter);
    [category,brand,sort].forEach(el => el.addEventListener('change',filter));
    az.addEventListener('click',e => {const button=e.target.closest('[data-letter]');if(!button)return;letter=button.dataset.letter;az.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter();});
    root.querySelector('[data-reset]').addEventListener('click',()=>{search.value='';category.value='';brand.value='';sort.value='asc';letter='';az.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.letter==='')));filter();});
    availability(); options(); filter();
    async function load() {
      if (busy || complete) return;
      const startingCount = grid.children.length;
      busy = true; failed = false; availability(); filter();
      try {
        if (next) {
          const url = new URL(next, location.href);
          if (url.origin !== location.origin) throw new Error('Invalid page origin');
          url.searchParams.set('section_id', root.dataset.ufiDirectory);
          if (seen.has(url.href)) throw new Error('Repeated page');
          const response = await fetch(url.href);
          if (!response.ok) throw new Error('Could not load brands');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (doc.body.textContent.includes('Liquid error')) throw new Error('Directory rendering failed');
          const incoming = [...doc.querySelectorAll('[data-ufi-directory]')].find(el => el.dataset.ufiDirectory === root.dataset.ufiDirectory);
          if (!incoming?.querySelector('[data-grid]')) throw new Error('Missing directory');
          const nextPage = incoming.querySelector('[data-next]')?.getAttribute('href');
          if (nextPage) {
            const following = new URL(nextPage, location.href);
            following.searchParams.set('section_id', root.dataset.ufiDirectory);
            if (following.origin !== location.origin || following.href === url.href || seen.has(following.href)) throw new Error('Invalid next page');
          }
          const handles = new Set([...grid.children].map(x => x.dataset.handle));
          incoming.querySelectorAll('[data-grid] > a').forEach(item => {
            const existing = [...grid.children].find(current => normalise(current.dataset.name) === normalise(item.dataset.name));
            if (existing?.dataset.handle.startsWith('vendor:')) existing.replaceWith(item);
            else if (!handles.has(item.dataset.handle)) { handles.add(item.dataset.handle); grid.append(item); }
          });
          // Commit pagination only after a successful response so errors remain retryable.
          seen.add(url.href); next = nextPage;
        }
        remainingVendors().slice(0, Math.max(0, 50 - (grid.children.length - startingCount))).forEach(appendVendor);
      } catch (_) { failed = true; }
      finally { busy = false; availability(); options(); filter(); }
    }
    more.addEventListener('click', load);
  }
  document.querySelectorAll('[data-ufi-directory]').forEach(initialise);
  if(!window.ufiDirectoryListener){document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ufi-directory]').forEach(initialise));window.ufiDirectoryListener=true;}
})();



